import { jsx as l } from "react/jsx-runtime";
const r = (e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...e,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1.5 8a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0ZM3 8c0 2.757 2.243 5 5 5s5-2.243 5-5-2.243-5-5-5-5 2.243-5 5Zm4.226.736 3.48-3.478.448 1.673-3.928 3.926L4.65 8.281 5.711 7.22l1.515 1.516Z",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  r as CheckCircle
};
